import Swal from 'sweetalert2';

function isFunction(functionToCheck) {
    return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
}

export const SweetAlert = {
    swal(...args: any[]) {
        if (args[0]) {
            delete args[0].closeOnConfirm;
            delete args[0].closeOnCancel;
        }
        let result = Swal.apply(null, args);
        if (result && isFunction(result.then) && args[1] && isFunction(args[1])) {
            result.then(param => {
                //console.log('SweetAlert:', param);
                if (param && param.value) {
                    args[1](param.value);
                }
                else {
                    args[1](false);
                }
            });
        }
    }
};
